import { BoxRadius, Color } from '@genial/design-tokens';

/** Cores sem token exato no design system — Figma Gerador de Relatórios */
const figmaOnly = {
  carouselBadgeBg: '#EEF4FF',
  carouselBadgeText: '#1726B6',
  carouselGenerateLink: '#0029E7',
  documentSubtitle: '#05092299',
  detailsButtonDisabled: '#05092261',
} as const;

export const reportGeneratorTheme = {
  colors: figmaOnly,
  card: {
    bg: Color['neutral.white'],
    borderColor: Color['neutral.lightest'],
    title: Color['neutral.black'],
    description: Color['neutral.black'],
  },
  table: {
    rowBg: Color['neutral.white'],
    headBg: Color['scale.base.100'],
    historyBg: Color['scale.base.100'],
    borderColor: Color['neutral.lightest'],
    frameBorderRadius: '20px',
    listPanelBorderRadius: BoxRadius.md,
    listPanelBorderColor: Color['scale.base.200'],
    itemBorderRadius: BoxRadius.sm,
    itemGap: '8px',
    columnHeaderColor: Color['brand.primary.principal'],
    valueColor: Color['brand.primary.principal'],
    documentSubtitleColor: figmaOnly.documentSubtitle,
  },
  carousel: {
    gap: 16,
    dotActive: Color['neutral.darkest'],
    dotInactive: Color['neutral.lightest'],
  },
  newBadge: {
    color: figmaOnly.carouselBadgeText,
    bg: figmaOnly.carouselBadgeBg,
  },
  details: {
    buttonBg: Color['brand.primary.principal'],
    buttonDisabledBg: figmaOnly.detailsButtonDisabled,
  },
  page: {
    bg: Color['background'],
    paddingTop: '42px',
    paddingHorizontal: {
      mobile: 'inset.xs',
      tablet: 'inset.xs',
      desktop: 'inset.md',
    },
  },
} as const;
